import React, { FunctionComponent } from 'react';

import { AppBarProps, default as MuiAppBar } from '@mui/material/AppBar';

const AppBar: FunctionComponent<AppBarProps> = ({
  position,
  children,
  sx,
  title,
}: AppBarProps) => {
  return (
    <MuiAppBar position={position} sx={sx} title={title}>
      {children}
    </MuiAppBar>
  );
};
export default AppBar;
